function WheelDirection(e){
    if(e.type === 'DOMMouseScroll') return e.originalEvent.detail > 0 ? 1 : -1;
    if(e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY > 0 ? -1 : 1;
    return e.originalEvent.wheelDelta > 0 ? -1 : 1;
}

export default WheelDirection;



// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/component/wheelDirection.js